<line-chart
  [customization]="customization()"
  [resource]="ddosTraffic"
  [metadata]="ddosMetadata()"
  [defaultPeriod]="'1D'"
  [viewMode]="viewMode()"
  [(dateRange)]="dateRangeOfInterest"
>
  <div chart-title class="chart__title-row">
    <h3 class="title-with-icon">
      <svg-icon src="assets/images/icons/chart.svg" class="black-medium"></svg-icon>
      <span>{{ "Chart.TrafficGraph.DDoS" | translate }}</span>
    </h3>
    <p>{{ "Chart.TrafficGraph.DDoS.Explainer" | translate }}</p>
  </div>
  <ng-container chart-header-left>
    <line-chart-subject-dropdown
      [subjects]="ddosSubjects()"
      [(selected)]="selectedSubject"
      [label]="'Chart.Ddos.SelectConnection'"
    />
  </ng-container>
  <div chart-footer class="chart__footer-controls">
    <line-chart-radio-buttons [options]="ipVersionOptions" [(selected)]="ipVersion" />
    <line-chart-radio-buttons [options]="unitOptions" [(selected)]="unit" />
  </div>
  <div chart-center class="chart__happy-state">
    @if (ddosLoadError()) {
      <div>{{ "Chart.NoDataFoundReason" | translate: { reason: "error" } }}</div>
    } @else {
      <div>
        <svg-icon src="assets/images/icons/rocket.svg"></svg-icon>
        @if (selectedSubject()?.subject?.surfcertFilterEnabled) {
          <div>{{ "Chart.TrafficGraph.NotUnderAttack" | translate }}</div>
        } @else {
          <div>{{ "Chart.TrafficGraph.NoDDoSProtection" | translate }}</div>
        }
      </div>
    }
  </div>
</line-chart>
